import { render, staticRenderFns } from "./ImageSlider.vue?vue&type=template&id=2dd1b1b2"
import script from "./ImageSlider.vue?vue&type=script&lang=ts"
export * from "./ImageSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports